import * as React from 'react'
import Link from 'next/link'
import styled, { css } from 'styled-components'
import { ArrowRight } from 'svgIcons'
import { UrlObject } from 'url'

type Props = {
  showMoreBtn?: boolean
  href?: string | UrlObject
}

const SearchResultHeader: React.FC<Props> = ({
  showMoreBtn = false,
  href,
  children,
}) => {
  return (
    <StyledWrapper>
      <div className="sh-title">{children}</div>
      {showMoreBtn && (
        <Link href={href !== undefined ? href : ''}>
          <a className="sh-more-btn">
            더보기
            <ArrowRight />
          </a>
        </Link>
      )}
    </StyledWrapper>
  )
}

export default SearchResultHeader

const StyledWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  font-weight: 500;
  .sh-title {
    font-size: 16px;
    color: #999999;
  }
  .sh-more-btn {
    display: flex;
    align-items: center;
    font-size: 12px;
    gap: 3px;
    color: #999999;
    svg {
      width: 10px;
      height: 10px;
    }
  }

  ${({ theme }) =>
    theme.isMobile &&
    css`
      padding: 22px 20px 0;
      height: 50px;
      align-items: flex-start;
      .sh-title {
        font-size: 12px;
      }
    `}
`
